import { render, staticRenderFns } from "./AboutContent.vue?vue&type=template&id=b5396b66&scoped=true&"
import script from "./AboutContent.vue?vue&type=script&lang=js&"
export * from "./AboutContent.vue?vue&type=script&lang=js&"
import style0 from "./AboutContent.vue?vue&type=style&index=0&id=b5396b66&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5396b66",
  null
  
)

export default component.exports